import { useTranslation } from 'react-i18next';

import {
    Body1,
    Button,
    Heading1,
    HorizontalDivider,
    List,
    ListItem,
    Stack,
} from '@myphx-engineering/phx-design-system';

import type { UnclaimedPrescriberOrderInfoFragment } from '../../../../graphql/generated/graphql';
import { UnclaimedPrescriptionDescription } from '../UnclaimedPrescriptionDescription';

type VerifyPrescriptionNoAttemptsProps = {
    prescriberOrder: UnclaimedPrescriberOrderInfoFragment;
};

export const VerifyPrescriptionNoAttempts = ({
    prescriberOrder,
}: VerifyPrescriptionNoAttemptsProps) => {
    const { t } = useTranslation();

    const handleClick = () => {
        location.href = `tel:+18445593471`;
    };

    return (
        <Stack gap="lg">
            <Heading1>{t('verifyPrescription.noAttempts.title')}</Heading1>
            <UnclaimedPrescriptionDescription
                prescriberOrder={prescriberOrder}
            />
            <HorizontalDivider />
            <Body1>{t('verifyPrescription.noAttempts.body')}</Body1>
            <List type="ordered">
                <Stack gap="sm">
                    {/* TODO: Fix List and ListItem ordered text styling:  https://linear.app/prescryptive/issue/MYPT-73/listlistitem-ordered-text-styling */}
                    <Body1>
                        <ListItem>
                            {t('verifyPrescription.noAttempts.point1')}
                        </ListItem>
                    </Body1>
                    <Body1>
                        <ListItem>
                            {t('verifyPrescription.noAttempts.point2')}
                        </ListItem>
                    </Body1>
                </Stack>
            </List>
            <Button onClick={handleClick}>
                {t('verifyPrescription.noAttempts.contactUs')}
            </Button>
        </Stack>
    );
};
